import type { LegalSection } from './legal-section';

export const TERMS_FINAL: readonly LegalSection[] = [
  {
    title: '10. Causas de suspensión y resolución (pre-ban / ban)',
    body: `Causas de resolución inmediata: (i) cuentas múltiples/identidades falsas, (ii) envío de datos fraudulentos, (iii) infracción de leyes o términos de Instagram, (iv) inclusión en listas de sanciones internacionales.`,
  },
  {
    title: '13. Propiedad intelectual',
    body: `El Collector cede a La divina comedia sa con carácter exclusivo y mundial todos los derechos de explotación sobre el contenido aportado para su integración en la base de datos de la plataforma.`,
  },
  {
    title: '14. Confidencialidad y no-circunvención',
    body: `El Collector mantendrá confidencialidad sobre las reglas internas y precios durante 24 meses tras la finalización. No podrá contactar a los creadores identificados para ofrecer servicios análogos durante 12 meses.`,
  },
  {
    title: '18. Ley aplicable y jurisdicción',
    body: `Estos Términos se rigen por la legislación vigente. Para cualquier controversia, las partes se someten a los juzgados y tribunales de la Ciudad de Panamá, renunciando a cualquier otro fuero.`,
  },
];
